import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import styled from '@emotion/styled'
import DonorInfoFields from '../donor-info-fields'
import ACHInputs from './ach-inputs'
import {
  registerForm,
  unregisterForm,
} from '../../../steps/single/utils/single-step-form-orchestrator'
import {
  makeACHWithDonorInfoValidationSchema,
  makeACHWithDonorInfoDefaultValues,
  ACHWithDonorInfoFormData,
} from './ach-validation'
import useOrder from 'modules/order/state/order/use-order'

const AccordionWrapper = styled.div`
  padding: 8px 0 0 0;
`

export const ACHAccordionContent = () => {
  const { t } = useTranslation()
  const order = useOrder()

  const form = useForm<ACHWithDonorInfoFormData>({
    defaultValues: makeACHWithDonorInfoDefaultValues(order.contact.value),
    resolver: yupResolver(makeACHWithDonorInfoValidationSchema(t, order.contact.schema)),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  // Register the form with the orchestrator
  useEffect(() => {
    registerForm({
      name: 'ach',
      formRef: form,
      errorMessage: 'Please fill in all required ACH fields',
    })

    return () => unregisterForm({ name: 'ach' })
  }, [form])

  return (
    <FormProvider {...form}>
      <AccordionWrapper>
        {/* Donor Info Fields: Email, First Name, Last Name */}
        <DonorInfoFields />

        {/* ACH Fields: Routing Number, Account Number */}
        <ACHInputs />
      </AccordionWrapper>
    </FormProvider>
  )
}
